/* ============================================================
   AYEMOON — Craft Custom : interactions
   ============================================================ */
(() => {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- En-tête : ombre au défilement ---------- */
  const header = $('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Menu mobile ---------- */
  const burger = $('[data-burger]');
  const mobileNav = $('[data-mobile-nav]');
  if (burger && mobileNav) {
    burger.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('open');
      burger.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------- Menu mobile : sous-menus déroulants ---------- */
  $$('[data-mobile-nav-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const item = toggle.closest('.mobile-nav__item');
      const submenu = item ? item.querySelector('[data-mobile-nav-submenu]') : null;
      if (!submenu) return;
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      submenu.hidden = expanded;
    });
  });

  /* ---------- Bandeau d'annonce rotatif ---------- */
  const annMsg = $('[data-announcement-message]');
  if (annMsg) {
    try {
      // dataset décode les entités HTML (l'attribut est échappé côté Liquid)
      const messages = JSON.parse(annMsg.dataset.messages || '[]').filter(Boolean);
      if (messages.length > 1) {
        let idx = 0;
        setInterval(() => {
          annMsg.classList.add('is-fading');
          setTimeout(() => {
            idx = (idx + 1) % messages.length;
            annMsg.textContent = messages[idx];
            annMsg.classList.remove('is-fading');
          }, 400);
        }, 5000);
      }
    } catch (e) { /* messages invalides : on garde le premier */ }
  }

  /* ---------- Apparition au défilement ---------- */
  const revealEls = $$('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  /* ============================================================
     PANIER (tiroir + barre de progression livraison gratuite)
     ============================================================ */
  const drawer = $('[data-cart-drawer]');
  const overlay = $('#PageOverlay');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) {
      overlay.hidden = false;
      requestAnimationFrame(() => overlay.classList.add('show'));
    }
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) {
      overlay.classList.remove('show');
      setTimeout(() => { overlay.hidden = true; }, 350);
    }
    document.body.style.overflow = '';
  }

  function updateFreeShipping(scope, totalCents) {
    $$('[data-fsb]', scope).forEach((bar) => {
      const threshold = parseInt(bar.getAttribute('data-threshold') || '12000', 10);
      const msgEl = $('[data-fsb-message]', bar);
      const fill = $('[data-fsb-fill]', bar);
      const tplRemaining = bar.getAttribute('data-msg-remaining') || '';
      const tplUnlocked = bar.getAttribute('data-msg-unlocked') || '';
      const pct = Math.min(100, Math.round((totalCents / threshold) * 100));
      if (fill) fill.style.width = pct + '%';
      if (totalCents >= threshold) {
        bar.classList.add('fsb--unlocked');
        if (msgEl) msgEl.innerHTML = tplUnlocked;
      } else {
        bar.classList.remove('fsb--unlocked');
        const remaining = formatMoney(threshold - totalCents);
        if (msgEl) msgEl.innerHTML = tplRemaining.replace('{amount}', '<strong>' + remaining + '</strong>');
      }
    });
  }

  function cartItemHTML(item, removeLabel) {
    const variant = item.variant_title ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '';
    const img = item.image
      ? '<img src="' + item.image + '" alt="' + (item.product_title || '').replace(/"/g, '') + '" loading="lazy">'
      : '';
    return (
      '<div class="cart-item" data-key="' + item.key + '">' +
        '<div class="cart-item__media">' + img + '</div>' +
        '<div>' +
          '<p class="cart-item__title">' + item.product_title + '</p>' +
          variant +
          '<div class="cart-item__row">' +
            '<div class="qty-selector">' +
              '<button type="button" data-cart-dec data-key="' + item.key + '" aria-label="-">&minus;</button>' +
              '<input value="' + item.quantity + '" readonly tabindex="-1" aria-label="' + (document.documentElement.lang === 'en' ? 'Quantity' : 'Quantité') + '">' +
              '<button type="button" data-cart-inc data-key="' + item.key + '" aria-label="+">+</button>' +
            '</div>' +
            '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="cart-item__remove" data-cart-remove data-key="' + item.key + '">' + removeLabel + '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function renderCart(cart, labels) {
    if (!drawer) return;
    const body = $('[data-cart-items]', drawer);
    const footer = $('[data-cart-footer]', drawer);
    const empty = $('[data-cart-empty]', drawer);
    const subtotalEl = $('[data-cart-subtotal]', drawer);

    $$('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    if (!cart.item_count) {
      if (body) body.innerHTML = '';
      if (footer) footer.hidden = true;
      if (empty) empty.hidden = false;
    } else {
      if (empty) empty.hidden = true;
      if (footer) footer.hidden = false;
      if (body) body.innerHTML = cart.items.map((item) => cartItemHTML(item, labels.remove)).join('');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    }
    updateFreeShipping(drawer, cart.total_price);
    updateFreeShipping(document, cart.total_price);
  }

  async function refreshCart(openAfter, labels) {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      renderCart(cart, labels || { remove: 'Retirer' });
      if (openAfter) openDrawer();
    } catch (e) { /* panier inaccessible : on ne bloque pas */ }
  }

  function drawerLabels() {
    if (!drawer) return { remove: 'Retirer' };
    return { remove: drawer.getAttribute('data-remove-label') || 'Retirer' };
  }

  if (drawer) {
    $$('[data-open-cart]').forEach((btn) =>
      btn.addEventListener('click', (e) => { e.preventDefault(); refreshCart(true, drawerLabels()); })
    );
    $$('[data-close-cart]').forEach((btn) => btn.addEventListener('click', closeDrawer));
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

    drawer.addEventListener('click', async (e) => {
      const dec = e.target.closest('[data-cart-dec]');
      const inc = e.target.closest('[data-cart-inc]');
      const rem = e.target.closest('[data-cart-remove]');
      const step = dec || inc || rem;
      if (!step) return;
      const key = step.getAttribute('data-key');
      let quantity = 0;
      if (dec || inc) {
        const input = step.parentElement.querySelector('input');
        const current = parseInt(input.value, 10) || 1;
        quantity = dec ? current - 1 : current + 1;
        if (quantity < 0) quantity = 0;
      }
      step.disabled = true;
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        });
        await refreshCart(false, drawerLabels());
      } catch (err) { step.disabled = false; }
    });

    // État initial (barre de progression) dès le chargement
    refreshCart(false, drawerLabels());
  }

  /* ---------- Ajout au panier en AJAX ---------- */
  $$('form[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = $('[data-add-to-cart]', form);
      const original = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = btn.getAttribute('data-adding-text') || original;
      }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'error');
        }
        await refreshCart(true, drawerLabels());
      } catch (err) {
        if (btn) {
          btn.textContent = btn.getAttribute('data-error-text') || original;
          setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 2200);
          return;
        }
      }
      if (btn) { btn.textContent = original; btn.disabled = false; }
    });
  });

  /* ---------- Sélecteur de quantité (fiche produit) ---------- */
  $$('[data-qty-btn]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input');
      if (!input) return;
      let v = parseInt(input.value, 10) || 1;
      v += parseInt(btn.getAttribute('data-delta') || '1', 10);
      if (v < 1) v = 1;
      input.value = v;
    });
  });

  /* ============================================================
     FICHE PRODUIT : variantes + galerie
     ============================================================ */
  $$('[data-product-section]').forEach((section) => {
    const jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    let product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    const form = $('form[data-product-form]', section);
    const priceEl = $('[data-product-price]', section);
    const compareEl = $('[data-product-compare]', section);
    const addBtn = $('[data-add-to-cart]', section);
    const idInput = form ? form.querySelector('input[name="id"]') : null;
    const picker = $('[data-variant-picker]', section);

    function currentVariant() {
      const checked = $$('input[type="radio"]:checked', picker || section);
      const values = checked.map((r) => r.value);
      return product.variants.find((v) => {
        if (v.option1 !== undefined && values[0] !== undefined && v.option1 !== values[0]) return false;
        if (v.option2 !== undefined && values[1] !== undefined && v.option2 !== values[1]) return false;
        if (v.option3 !== undefined && values[2] !== undefined && v.option3 !== values[2]) return false;
        return true;
      });
    }

    function paintLabels() {
      $$('.variant-option', section).forEach((group) => {
        const checked = $('input:checked', group);
        const target = $('[data-option-value]', group);
        if (target && checked) target.textContent = checked.value;
      });
    }

    function onVariantChange() {
      const variant = currentVariant();
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (addBtn) {
        const available = variant.available;
        addBtn.disabled = !available;
        const label = addBtn.getAttribute(available ? 'data-add-label' : 'data-soldout-label');
        if (label) addBtn.querySelector('[data-add-label-text]').textContent = label;
      }
      if (variant.featured_image) {
        const thumb = $('[data-gallery-thumb][data-media-id="' + variant.featured_image.id + '"]', section);
        if (thumb) thumb.click();
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      paintLabels();
    }

    if (picker) {
      picker.addEventListener('change', onVariantChange);
      // État initial : coche la première variante disponible
      const first = product.variants.find((v) => v.available) || product.variants[0];
      if (first && idInput) {
        idInput.value = first.id;
        ['option1', 'option2', 'option3'].forEach((opt, idx) => {
          if (first[opt] === undefined || first[opt] === null) return;
          const radio = $('input[type="radio"][name="' + opt + '"][value="' + first[opt].replace(/"/g, '\\"') + '"]', picker);
          if (radio) radio.checked = true;
        });
      }
      onVariantChange();
    }

    /* Galerie */
    const main = $('[data-gallery-main]', section);
    const thumbs = $$('[data-gallery-thumb]', section);
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (!main) return;
        const type = thumb.getAttribute('data-media-type');
        const src = thumb.getAttribute('data-full');
        if (type === 'video' || type === 'external_video') {
          main.innerHTML = '<video src="' + src + '" controls playsinline preload="metadata" style="width:100%;height:100%;object-fit:cover;"></video>';
        } else {
          main.innerHTML = '<img src="' + src + '" alt="" loading="eager">';
        }
      });
    });
  });

  /* ============================================================
     TÉMOIGNAGES : slider
     ============================================================ */
  $$('[data-testimonials]').forEach((el) => {
    const track = $('[data-ts-track]', el);
    const slides = $$('[data-ts-slide]', el);
    const dots = $$('[data-ts-dot]', el);
    const prev = $('[data-ts-prev]', el);
    const next = $('[data-ts-next]', el);
    if (!track || slides.length < 2) return;
    let idx = 0;
    let timer = null;

    function go(n) {
      idx = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + idx * 100 + '%)';
      dots.forEach((d, k) => d.classList.toggle('is-active', k === idx));
    }
    function auto() {
      stop();
      timer = setInterval(() => go(idx + 1), 7000);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    if (prev) prev.addEventListener('click', () => { go(idx - 1); auto(); });
    if (next) next.addEventListener('click', () => { go(idx + 1); auto(); });
    dots.forEach((d, k) => d.addEventListener('click', () => { go(k); auto(); }));
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', auto);
    auto();
  });

  /* ============================================================
     VIDÉO : lecture au clic (jamais plein écran imposé)
     ============================================================ */
  $$('[data-video-frame]').forEach((frame) => {
    const btn = $('[data-video-play]', frame);
    if (!btn) return;
    btn.addEventListener('click', () => {
      const src = frame.getAttribute('data-video-src');
      if (!src) return;
      const video = document.createElement('video');
      video.src = src;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('style', 'width:100%;height:100%;object-fit:cover;');
      frame.innerHTML = '';
      frame.appendChild(video);
      frame.style.cursor = 'default';
    }, { once: true });
  });
})();
